import { render, staticRenderFns } from "./s2-5.vue?vue&type=template&id=45b32ac9&scoped=true&"
import script from "./s2-5.vue?vue&type=script&lang=js&"
export * from "./s2-5.vue?vue&type=script&lang=js&"
import style0 from "./s2-5.vue?vue&type=style&index=0&id=45b32ac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b32ac9",
  null
  
)

export default component.exports